<template>
    <div class="col-md-12 flex-container">
        <div class="w-100">
            <div class="col-md-12">
                <div class="h2">Receive goods</div>
                <div class="row my-3">
                    <div class="col-md-4 pl-0">
                        <div class="form-group">
                            <div class="col-md-6">
                                <label class="d-block mb-0 font-weight-bold">Select warehouse</label>
                                <div class="bg-whiterounded-lg div-focus border-2">
                                    <v-select
                                        :options="warehouseList"
                                        v-model="warehouseId"
                                        label="nickname"
                                        @input="focusOnScan"
                                    >
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-12">
                                <div class="d-flex">
                                    <label class="d-block mb-0 font-weight-bold pr-3" for="receiveAll">Select all colli</label>
                                    <input type="checkbox"
                                           v-model="receiveAll"
                                           style="width: 18px;"
                                           id="receiveAll"
                                           @click="focusOnScan"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-12">
                                <label class="d-block mb-0 font-weight-bold">Scan barcode</label>
                                <stream-barcode-reader @decode="onDecode" @loaded="onLoaded"></stream-barcode-reader>
                                <div class="d-flex align-items-center">
                                    <div class="bg-white border rounded-lg div-focus border-2">
                                        <input type="text"
                                               v-model="barcode"
                                               autocomplete="off"
                                               class="form-control border-0  shadow-none form-input"
                                               placeholder="Scan..."
                                               ref="scanCode"
                                               @change="onScanBarcode"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 d-flex justify-content-end align-items-center pr-0">
                        <div class="btn-group float-right shadow-sm desktop-only" role="group" v-if="!isMobile">
                            <a :href="`/receive-colli`"
                               class="btn btn-success float-right d-flex align-items-center receive-colli"
                               title="Receive colli">
                                <span class="material-icons-outlined cursor-pointer mr-1">download</span>
                                <span>Receive colli</span>
                            </a>

                            <a :href="`/create-barcode/${warehouseId.id}`"
                               class="btn btn-success float-right d-flex align-items-center"
                               title="Create colli">
                                <span class="material-icons-outlined cursor-pointer mr-1">post_add</span>
                                <span>Create colli</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="scanCodeError!==''" class="scan alert alert-danger">
                <i>{{ scanCodeError }}</i>
            </div>
            <div v-if="scanCodeSuccess!=='' && collis.length" class="scan alert alert-success">
                <i>{{ scanCodeSuccess }}</i>
                <br/><br>
                <span>Client name: {{ collis[0].client.name }}</span><br/>
                <span v-if="collis.length > 1">Colli recieved: {{ collis.length }}<br/></span>
                <span v-if="collis.length > 1">Product reference: {{ collis[0].reference }}<br/></span>
                <span>Reference of booking: </span><span
                v-if="collis[0].booking !== null"> {{ collis[0].booking.reference }}</span>
                <br/>
                <span v-if="collis.length === 1">Colli number: {{ collis[0].colli }} / {{ collis[0].totalColliAmountByColliBatch }}<br/></span>
            </div>

            <div v-if="partialReceivingWarning !== ''" class="scan alert alert-warning">
                <i>{{ partialReceivingWarning }}</i>
            </div>

            <div class="position-relative pagination-control" v-if="scanCodeSuccess !== '' && !isMobile">
                <div class="pt-3">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                            <tr>
                                <th class="border-right text-left">ID</th>
                                <th class="border-right text-left">Client</th>
                                <th class="border-right text-left">Booking</th>
                                <th class="border-right text-left">Reference</th>
                                <th class="border-right text-left">Name</th>
                                <th class="border-right text-left">Delivery</th>
                                <th class="border-right text-left">Volume</th>
                                <th class="border-right text-left">Weight</th>
                                <th class="border-right text-left">Colli</th>
                            </tr>
                            </thead>
                            <tbody class="table-bordered">
                            <tr v-for="colli in collis">
                                <td> {{ colli.id }}</td>
                                <td> {{ colli.client.name }}</td>
                                <td><span v-if="colli.booking!=null && colli.booking.id != 1"> #{{
                                        colli.booking.id
                                    }} </span></td>
                                <td> {{ colli.reference }}</td>
                                <td> {{ colli.name }}</td>
                                <td> {{ colli.created }}</td>
                                <td> {{ colli.volume }}</td>
                                <td> {{ colli.weight }}</td>
                                <td> {{ colli.colli }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <template>
            <div>
                <nested-booking-exist-modal
                    :nestedBooking="nestedBooking"
                        :visible="showNestedModal"
                    @close="showNestedModal = false"
                />

            </div>
        </template>
    </div>
</template>
<script>
import 'vue-select/dist/vue-select.css';
import StreamBarcodeReader from "./vue-barcode-reader/StreamBarcodeReader.vue";
import NestedBookingExistModal from "./reusable/NestedBookingExistModal.vue";

export default {
    name: "ReceiveGoods",
    props: {
        isMobile: {type: Boolean, required: true},
        defaultWarehouse: {type: Object, required: false, default: null},
    },
    components: {StreamBarcodeReader, NestedBookingExistModal},

    data() {
        return {
            warehouseList: [
                {id: '', nickname: ''},
            ],
            warehouseId: this.defaultWarehouse ? this.defaultWarehouse : {'id': 1, nickname: 'Brøndby'},
            isSubmit: false,
            collis: [],
            scanCodeError: '',
            scanCodeSuccess: '',
            partialReceivingWarning: '',
            barcode: '',
            receiveAll: 0,
            loading: false,
            showNestedModal: false,
            nestedBooking: null,

        }
    },
    methods: {
        onScanBarcode() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            setTimeout(() => {
                axios.get(
                        `/scan-barcode/${this.barcode}/${this.warehouseId.id}`,
                        {params: {receiveAll: this.receiveAll}}
                    )
                    .then(({data}) => {
                        if (data.message != null) {

                            if (data.data.newBooking) {
                                this.nestedBooking = data.data.newBooking
                                this.showNestedModal = true

                            } else {

                                this.scanCodeError = `Colli ${this.barcode} could not be found`;

                            }
                            this.scanCodeSuccess = '';
                            this.collis = [];
                            this.partialReceivingWarning = '';

                        } else {
                            this.scanCodeError = '';
                            this.scanCodeSuccess = `Colli ${this.barcode} received`;
                            this.collis = data.data;

                            // Informational, non-blocking warning: show it when the scanned
                            // colli's booking is not yet fully received. The input stays
                            // focused so the user can keep scanning other colli. Booking id 1
                            // is the placeholder booking (its number is hidden elsewhere in
                            // this view), so we skip the warning for it too.
                            const scannedBooking = (data.data && data.data.length) ? data.data[0].booking : null;
                            if (data.receiving && !data.receiving.fullyReceived
                                && scannedBooking != null && scannedBooking.id != 1) {
                                this.partialReceivingWarning =
                                    `Booking partially received: ${data.receiving.receivedColliCount} of ${data.receiving.totalColliCount} colli received.`;
                            } else {
                                this.partialReceivingWarning = '';
                            }
                        }
                        this.barcode = '';
                    }).catch(
                        (err) => {
                            // A failed scan must not leave a stale "partially received"
                            // warning on screen — the warning only describes a successful scan.
                            this.partialReceivingWarning = '';
                            this.scanCodeSuccess = '';
                            this.collis = [];
                            this.scanCodeError = (err.response && err.response.data && err.response.data.message) ?
                                err.response.data.message :
                                'Error';
                            if (this.scanCodeError === 'Booking is already delivered/rejected. The good requires a new label. Print a new label from desktop') {
                                let audio = new Audio('/assets/beep-warning-6387.mp3');
                                audio.play();
                            }
                            this.barcode = '';
                        }
                )
                    .finally(() => {
                        this.loading = false;
                        this.focusOnScan();
                    });
            }, 50);
        },
        validation() {
            this.isSubmit = true;
        },
        fetchData() {
            axios.get('/warehouse-list')
                .then(({data}) => {
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        this.warehouseList.push({
                            id: value.id,
                            nickname: value.nickname,
                        });
                    });
                    this.setDefaultWarehouse();
                }).catch()
                .finally(() => {
                    this.focusOnScan();
                });
        },
        setDefaultWarehouse() {
            const warehouses = this.warehouseList.filter(warehouse => warehouse.id !== '');
            if (!warehouses.length) {
                return;
            }

            const selectedWarehouse = warehouses.find(warehouse => warehouse.id === this.warehouseId.id);
            if (!selectedWarehouse) {
                this.warehouseId = warehouses[0];
            }
        },
        focusOnScan() {
            this.$nextTick(() => {
                this.$refs.scanCode.focus();
            });
        },

        onDecode(value) {
            this.barcode = value;
            this.onScanBarcode();
        },
        onLoaded() {
            console.log('StreamBarcodeReader is loaded');
        },
    },
    created() {
        return this.fetchData()
    },
}
</script>
<style>
.scan-error {
    color: red;
}

.receive-colli {
    margin-right: 10px;
}

.scan {
    margin-top: 10px;
    margin-left: 10px;
}

@media screen and (max-width: 768px) {
    .desktop-only {
        display: none;
    }
}

</style>
